<button (click)="handleOpenGamesDropdown()" class="grid-item-0 games-button">
  <app-icon [icon]="'gamepad'" [width]="20" [pathStroke]="'#e04747'"></app-icon>
  <span class="games-name">Games</span>
  <span class="games-arrow" [class.rotate]="!gamesDropdown.isCollapsed()">
    <app-icon icon="arrow" />
  </span>
  <app-dropdown #gamesDropdown [width]="200" [maxHeight]="500" class="games-dropdown">
    @for (item of games(); track item.title) {
    <app-dropdown-item [routerLink]="item.route" class="game-item" [class.active]="item.isActive">
      <app-icon [icon]="item.icon" [width]="16" [hasHoverState]="item.hasHoverState" [pathStroke]="'#CE372E'"></app-icon>
      <span class="game-title">{{ item.title }}</span>
      @if (item.value) {
      <span class="link-badge badge badge_red badge_rounded badge_font-l">
        <app-icon [icon]="'coin'" class="balance-icon" [width]="12"></app-icon>
        {{ item.value }}
      </span>
      }
      <button type="button" (click)="$event.preventDefault(); $event.stopPropagation(); setGames(item)" class="button mark-button" [class.active]="item.isActive">
        <span class="mark"></span>
      </button>
    </app-dropdown-item>
    }
  </app-dropdown>
</button>
<div class="selected-games">
  @for (game of selectedGames(); track game.title) {
  <a [routerLink]="game.route" class="button medium red-secondary">
    <app-icon [icon]="game.icon" [width]="16" [hasHoverState]="game.hasHoverState" [pathStroke]="'#CE372E'"></app-icon>
    @if(game.value) {
    <span class="value-wrapper">
      <app-icon [icon]="'coin'" class="balance-icon" [width]="12"></app-icon>
      {{ game.value }}
    </span>
    }
  </a>
  }
</div>
